import { render, staticRenderFns } from "./CRMNavCell.vue?vue&type=template&id=8555f282&scoped=true&"
import script from "./CRMNavCell.vue?vue&type=script&lang=js&"
export * from "./CRMNavCell.vue?vue&type=script&lang=js&"
import style0 from "./CRMNavCell.vue?vue&type=style&index=0&id=8555f282&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8555f282",
  null
  
)

export default component.exports